import moment from 'moment'

/**
 * @param  {int} timestamp
 * @return {string}
 */
function getWeekLabel(timestamp) {
  const start = moment(timestamp).startOf('week')
  const end = start.clone().endOf('week')
  return (start.format('MM (WW)') != '12 (01)' ? start : end).format('YYYY-WW')
}

export {
  getWeekLabel
}

export default {
  getWeekLabel
}